import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';

@Component({
	selector: 'page-coupons',
	templateUrl: 'coupons.html'
})
export class CouponsPage extends PageBase {
	public loader: any;
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}
	
	ngAfterViewInit() {
	}

	
	ionViewDidEnter() {
	}


}



// WEBPACK FOOTER //
// ./src/modules/coupons/pages/coupons/coupons.ts